angular.module('bmsApp.accounting')
	.factory('AccountingSvc', [
		'$rootScope',
		'$modal',
		'notify',
		'CRUDSvc',
		'ACCOUNTING_API',
		function ($rootScope,
				  $modal,
				  notify,
				  CRUDSvc,
				  ACCOUNTING_API) {

			return {
				index: function (params) {
					return CRUDSvc.get(ACCOUNTING_API.INDEX, params);
				},
				read: function (id) {
					return CRUDSvc.get(ACCOUNTING_API.READ + id);
				},
				overdueStats: function(params) {
					return CRUDSvc.get(ACCOUNTING_API.OVERDUE_STATS, params);
				},
				export: function (params) {
					var newParams = angular.extend({}, params, {
						'format': 'csv'
					});
					var query = $.param(newParams);
					window.open(ACCOUNTING_API.INDEX + '?' + query);
				},
				customerStatement: function (id, params) {
					return CRUDSvc.get(ACCOUNTING_API.CUSTOMER_STATEMENT + id, params);
				},
				outstandingCustomerInvoices: function (id) {
					return CRUDSvc.get(ACCOUNTING_API.OUTSTANDING_CUSTOMER_INVOICES + id);
				},
				showPaymentReceiptModal: function (customer, invoicePrototype, additionalInvoicePrototype) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/accounting/templates/paymentReceipt/PaymentReceiptModal.html',
						controller: 'PaymentReceiptModalCtrl',
						size: 'lg',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							customer: function () {
								return angular.copy(customer);
							},
							invoicePrototype: function () {
								return angular.copy(invoicePrototype);
							},
							additionalInvoicePrototype: function () {
								return additionalInvoicePrototype ? angular.copy(additionalInvoicePrototype) : undefined;
							}
						}
					});

					return modalInstance.result;
				},
				savePaymentReceipt: function (paymentReceipt) {
					return CRUDSvc.post(ACCOUNTING_API.CUSTOMER_PAYMENT_SAVE, paymentReceipt);
				},
				showCreditInvoiceModal: function (invoice) {
					var modalInstance = $modal.open({
						animation: true,
						templateUrl: 'ng/accounting/templates/creditInvoice/CreditInvoiceModal.html',
						controller: 'CreditInvoiceModalCtrl',
						size: 'lg',
						scope: $rootScope,
						backdrop: 'static', // disable click-outside closing modal
						resolve: {
							invoice: function () {
								return angular.copy(invoice);
							}
						}
					});

					modalInstance.result.then(function (result) {
						if (result.success === true) {
							notify({
								message: 'Invoice credited'
							});
						}
						else {
							notify({
								message: result.error,
								classes: 'error'
							});
						}
					}, function () {
						// closed
					});

					return modalInstance.result;
				},
				saveInvoiceCredit: function (creditInvoice) {
					return CRUDSvc.post(ACCOUNTING_API.CREDIT_INVOICE_SAVE, creditInvoice);
				},
				deleteCustomerPayment: function (id) {
					return CRUDSvc.get(ACCOUNTING_API.CUSTOMER_PAYMENT_DELETE + id);
				},
				vatRateOptions: function () {
					return CRUDSvc.get(ACCOUNTING_API.VAT_RATE_OPTIONS);
				},
				indexCustomerPayment: function(params){
					return CRUDSvc.get(ACCOUNTING_API.CUSTOMER_PAYMENT_Index, params);
				}
			};

		}
	])
	.constant('ACCOUNTING_API', {
		INDEX: 'api/accounting/invoices/index',
		OVERDUE_STATS: 'api/accounting/invoices/overdue-stats',
		READ: 'api/accounting/invoices/read/',
		CUSTOMER_STATEMENT: 'api/accounting/customer-statement/',
		OUTSTANDING_CUSTOMER_INVOICES: 'api/accounting/outstanding-customer-invoices/',
		CUSTOMER_PAYMENT_SAVE: 'api/accounting/customer-payment/save',
		CUSTOMER_PAYMENT_DELETE: 'api/accounting/customer-payment/delete/',
		CREDIT_INVOICE_SAVE: 'api/accounting/invoices/credit',
		VAT_RATE_OPTIONS: 'api/accounting/vat-rate/options',
		CUSTOMER_PAYMENT_Index: 'api/accounting/customer-payment/index'
	});
